import {DTNode, SnapchatDPACreativeNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {ServerNode} from 'common/src/modules/nodes/nodes.types';

export function serializeSnapchatDPANode(node: DTNode, newNode: ServerNode) {
  const creativeNode = node as SnapchatDPACreativeNode;

  return {
    ...newNode,
    type: creativeNode.type,
    externalAdHeadline: creativeNode.externalAdHeadline || [],
    externalAdCTA: creativeNode.externalAdCTA,
    displayUrl: creativeNode.displayUrl,
    identity: creativeNode.identity,
    additionalIdentity: creativeNode.additionalIdentity,
    trackingPixel: creativeNode.trackingPixel,
    adNameTemplate: creativeNode.adNameTemplate || null,
    mediaNameTemplate: creativeNode.mediaNameTemplate || null,
    brandName: creativeNode.brandName,
    isShareable: creativeNode.isShareable,
    isStandardButtonColor: creativeNode.isStandardButtonColor,
    isPublicPosts: creativeNode.isPublicPosts,
    clickTrackers: creativeNode.clickTrackers || [],
    impressionTrackers: creativeNode.impressionTrackers || [],
    previewItemUrls: creativeNode.previewItemUrls,
    isStaticCaption: creativeNode.isStaticCaption,
    textFields: creativeNode.textFields,
  };
}
